//Import Mixpanel SDK
import type { App } from "vue"
import Pusher from "pusher-js"

export type PusherPlugin = {
    /**
     * Permet de tracker un évènement sur Mixpanel
     * @param eventName - Nom de l'évènement
     * @param params - Paramètres de l'évènement
     * @returns
     */
    $init: (eventName: string, params?: Record<string, any>) => Promise<void>
}

export default {
    install: (app: App, options: { key: string }) => {
        if (!options.key) {
            throw new Error("Pusher key and cluster are required")
        }

        Pusher.logToConsole = import.meta.env?.VITE_DEBUG_PUSHER === "true"
        if (import.meta.env?.VITE_DEBUG_PUSHER === "true") {
            console.debug("Debug mode for Pusher is enabled")
        }
        const pusher = new Pusher(options.key?.split(":")[1], {
            cluster: "eu",
        })

        app.config.globalProperties.$pusher = pusher
        app.provide("pusher", pusher)
    },
}
